<script lang="ts">
    import { onMount } from 'svelte/internal'
    import DateSelectMonth from '../../_common/date-select-month.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { GridClass } from '../../_common/z/zgrid'
    import { buildReportGrid } from '../_shared/build-report-grid'
    import { inferChartConfig, REPORT_VIEW_MODE_OPTIONS } from '../_shared/report-chart-defaults'
    import type { ReportViewMode } from '../_shared/report-chart-defaults'
    import ReportChartViewer from '../_shared/report-chart-viewer.svelte'
    import type { ReportCatalogItem, ReportResponse } from '../../../modules/reportsApi/catalog/report-catalog'

    export let report: ReportCatalogItem = undefined

    const ENDPOINT = '/reports/financial/dre'

    let show = false
    let viewMode: ReportViewMode = window.store.reportViewMode
    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.currentMonth()
    let response: ReportResponse = null
    let grid: GridClass = null

    $: chartConfig = response ? inferChartConfig(response) : null

    function viewModeChanged() {
        window.store.reportViewMode = viewMode
    }

    onMount(() => {
        load()
    })

    async function load() {
        if (show) return
        show = true
        try {
            response = await window.api.reports.catalog.run(report?.endpoint || ENDPOINT, {
                from: dateSelect.from,
                to: dateSelect.to,
            })
            grid = buildReportGrid(response)
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load()
    }

    function currency(val: number) {
        return window.configs.currency + Number(val || 0).toFixed(2)
    }
</script>

<div class="relat-body">
    <Zframe title={response?.title || 'DRE Gerencial'} headline={response?.notes}>
        <Zact class="h-print mb-3">
            <DateSelectMonth on:change={dateChanged} startFrom={dateSelect.from} startTo={dateSelect.to} />
            {#if chartConfig}
                <div class="spacer" />
                <Zinput size={0} type="select" label="Exibição" options={REPORT_VIEW_MODE_OPTIONS} bind:value={viewMode} on:change={viewModeChanged} />
            {/if}
        </Zact>
        {#if response}
            <div class="dre-totals h-print mb-3">
                <div class="dre-total dre-total_result">
                    <div class="dre-total_label">Resultado operacional</div>
                    <div class="dre-total_value">{currency(response.totals.operatingResult)}</div>
                </div>
                <div class="dre-total">
                    <div class="dre-total_label">Movimentação fora do resultado</div>
                    <div class="dre-total_value">{currency(response.totals.nonOperatingMovement)}</div>
                </div>
            </div>
        {/if}
        {#if chartConfig && (viewMode === 'chart' || viewMode === 'report-chart')}
            <div class="mb-3">
                <ReportChartViewer {response} dimensionKey={chartConfig.dimensionKey} valueKey={chartConfig.valueKey} type={chartConfig.type} />
            </div>
        {/if}
        {#if !chartConfig || viewMode === 'report' || viewMode === 'report-chart'}
            <Zgrid {grid} />
        {/if}
    </Zframe>
</div>
<LoadSpinner {show}></LoadSpinner>

<style>
    .dre-totals {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
    }
    .dre-total {
        flex: 1 1 200px;
        padding: 10px 14px;
        border-radius: 8px;
        background: rgba(150, 150, 150, 0.08);
        border: 1px solid rgba(150, 150, 150, 0.14);
    }
    .dre-total_result {
        border-color: rgba(var(--menu-color), 0.4);
        background: rgba(var(--menu-color), 0.1);
    }
    .dre-total_label {
        font-size: 12px;
        opacity: 0.65;
        margin-bottom: 2px;
    }
    .dre-total_value {
        font-size: 20px;
        font-weight: 600;
    }
</style>
